import { CABIN__24 } from '@homeaway/svg-defs/lib/defs/CABIN__24';
import { CITY__24 } from '@homeaway/svg-defs/lib/defs/CITY__24';
import { HOUSE__24 } from '@homeaway/svg-defs/lib/defs/HOUSE__24';
import { CASTLE__24 } from '@homeaway/svg-defs/lib/defs/CASTLE__24';

export const DUMMY_CARD_ICONS = [
  CABIN__24,
  CITY__24,
  HOUSE__24,
  CASTLE__24
];
